import {Col, Button, Row} from 'antd';
import { Droppable } from 'react-beautiful-dnd';
import classNames from 'classnames';
import Course from './Course';

const ListOfCourses = ({ columns, courses, draggedCourse, sampleCoursesLoaded, openAddModal, loadSamples, removeCourse, rsSkillsGroup}) => {
  function printDroppable(column, columnType) {
    const currentDragged = draggedCourse != null ? courses[draggedCourse] : null;
    const isDropDisabled = currentDragged ? column.semester !== currentDragged.semester || columnType !== currentDragged.type : false;

    return (
      <Droppable droppableId={column.id} isDropDisabled={isDropDisabled}>
        {(provided, snapshot) => {
          const listClass = classNames('list-available', {
            'drag-over': snapshot.isDraggingOver,
            disabled: isDropDisabled,
          });

          return (
            <div ref={provided.innerRef} {...provided.droppableProps} className={listClass}>
              {column.courseIds.map((cid, idx) => {
                const course = courses[cid];
                if (!course) return null;
                return <Course key={course.id} course={course} index={idx} removeCourse={removeCourse} openAddModal={openAddModal} rsSkillsGroup={rsSkillsGroup} columnId={column.id} />;
              })}
              {provided.placeholder}
            </div>
          );
        }}
      </Droppable>
    );
  }

  return (
    <Col xs={24} lg={12} xl={8} className="base-available">
      <h3 className="section-title">Available Courses</h3>
      <div className="base-available-content">
        <div className="base-available-content-scroll">
          <div className="buttons-container">
            <Button type="primary" onClick={() => openAddModal(null)} className="button">
              Add course
            </Button>
            <Button onClick={loadSamples} disabled={sampleCoursesLoaded} className="button">
              {sampleCoursesLoaded ? 'Sample courses loaded' : 'Load sample courses'}
            </Button>
          </div>

          <h5 className="zone-title first">Mandatory Courses</h5>
          <Row>
            <Col span={12}>
              <h6 className="semester-title">winter semester</h6>
              {printDroppable(columns['mandatory-w'], 'mandatory')}
            </Col>
            <Col span={12}>
              <h6 className="semester-title">summer semester</h6>
              {printDroppable(columns['mandatory-s'], 'mandatory')}
            </Col>
          </Row>

          <h5 className="zone-title">Voluntary Courses</h5>
          <Row>
            <Col span={12}>
              <h6 className="semester-title">winter semester</h6>
              {printDroppable(columns['voluntary-w'], 'voluntary')}
            </Col>
            <Col span={12}>
              <h6 className="semester-title">summer semester</h6>
              {printDroppable(columns['voluntary-s'], 'voluntary')}
            </Col>
          </Row>
        </div>
      </div>
    </Col>
  );
};

export default ListOfCourses;
